import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../lib/api";

const MAX_TRIES = 8;
const INTERVAL_MS = 2500;

export function usePaymentStatus(sessionId) {
  const [state, setState] = useState(sessionId ? "checking" : "error");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await axios.get(`${API_BASE}/api/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
      } catch {
        return setState("error");
      }
      if (tries >= MAX_TRIES) return setState("pending");
      timer = setTimeout(poll, INTERVAL_MS);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return state;
}
